/**
 * Permission Service
 * Phase 5: RBAC & Permission System - M3
 * 
 * Frontend API service for permission management
 */

import api from './api';

const permissionService = {
  /**
   * Get all permissions (with optional filters)
   * @param {Object} filters - { search, isPage, isMainMenu, isActive, parentId }
   * @returns {Promise<Array>} List of permissions
   */
  getPermissions: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    if (filters.isPage !== undefined) {
      params.append('isPage', filters.isPage);
    }
    if (filters.isMainMenu !== undefined) {
      params.append('isMainMenu', filters.isMainMenu);
    }
    if (filters.isActive !== undefined) {
      params.append('isActive', filters.isActive);
    }
    if (filters.parentId !== undefined) {
      params.append('parentId', filters.parentId === null ? 'null' : filters.parentId);
    }
    
    const response = await api.get(`/permissions?${params.toString()}`);
    return response.data.data;
  },

  /**
   * Create new permission
   * @param {Object} permissionData - Permission data
   * @returns {Promise<Object>} Created permission
   */
  createPermission: async (permissionData) => {
    const response = await api.post('/permissions', permissionData);
    return response.data.data;
  },

  /**
   * Update permission
   * @param {String} permissionId - Permission ID
   * @param {Object} updates - Update data
   * @returns {Promise<Object>} Updated permission
   */
  updatePermission: async (permissionId, updates) => {
    const response = await api.put(`/permissions/${permissionId}`, updates);
    return response.data.data;
  },

  /**
   * Delete permission
   * @param {String} permissionId - Permission ID
   * @returns {Promise<Object>} Success message
   */
  deletePermission: async (permissionId) => {
    const response = await api.delete(`/permissions/${permissionId}`);
    return response.data;
  },

  /**
   * Get available permissions for current user's company
   * Company owners can create groups from these permissions
   * @returns {Promise<Array>} Available permissions
   */
  getAvailablePermissions: async () => {
    const response = await api.get('/permissions/available');
    return response.data.data;
  },

  /**
   * Get permissions for a specific user
   * @param {String} userId - User ID
   * @returns {Promise<Array>} User's permissions
   */
  getUserPermissions: async (userId) => {
    const response = await api.get(`/permissions/user/${userId}`);
    return response.data.data;
  }
};

export default permissionService;

